import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API_BASE,
    withCredentials: true,
});

// -------------- Auto-refresh on 401 --------------
// Any authenticated call that returns 401 will silently try /auth/refresh
// exactly once. If refresh succeeds we replay the original request; if it
// fails the caller receives the original 401 and the app logs out.
let _refreshInFlight = null;

function refreshOnce() {
    if (!_refreshInFlight) {
        _refreshInFlight = axios
            .post(`${API_BASE}/auth/refresh`, null, { withCredentials: true })
            .finally(() => { _refreshInFlight = null; });
    }
    return _refreshInFlight;
}

api.interceptors.response.use(
    (r) => r,
    async (err) => {
        const original = err.config || {};
        const status = err.response?.status;
        const url = original.url || "";
        const isAuthCall = url.includes("/auth/login")
            || url.includes("/auth/logout")
            || url.includes("/auth/refresh");
        if (status !== 401 || original._retried || isAuthCall) {
            throw err;
        }
        try {
            await refreshOnce();
            original._retried = true;
            return api(original);
        } catch (_) {
            throw err;
        }
    },
);

export function formatApiErrorDetail(detail) {
    if (detail == null) return "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .filter(Boolean)
            .join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}
